/**
 * Onam free gifts — two tiers, one gift in cart.
 * ₹500: free delivery only · ₹999: onam-500 gift
 */
window.IfFreeGift = (function () {
  const cfg = window.IF_FREE_GIFT || {};
  const M1 = cfg.m1 || cfg.delivery || 50000;
  const M2 = cfg.m2 || 99900;
  const THRESHOLD = M1;
  const nativeFetch = window.fetch.bind(window);
  let busy = false;
  let syncing = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function tiers() {
    if (cfg.tiers && cfg.tiers.length) return cfg.tiers;
    return [
      {
        handle: cfg.handle || 'onam-500',
        threshold: cfg.m2 || M2,
        discountCode: cfg.discountCode || 'ONAM500FREE',
        products: cfg.products || [],
      },
    ];
  }

  function products() {
    var out = [];
    tiers().forEach(function (t) {
      (t.products || []).forEach(function (p) {
        out.push(p);
      });
    });
    return out;
  }

  function giftVariantIds() {
    return products().map(function (p) {
      return String(p.variantId);
    });
  }

  function giftProductIds() {
    return products().map(function (p) {
      return String(p.id);
    });
  }

  function tierForHandle(handle) {
    if (!handle) return null;
    return (
      tiers().filter(function (t) {
        return t.handle === handle;
      })[0] || null
    );
  }

  function tierForVariant(id) {
    var sid = String(id);
    var found = null;
    tiers().forEach(function (t) {
      (t.products || []).forEach(function (p) {
        if (String(p.variantId) === sid || String(p.id) === sid) found = t;
      });
    });
    return found;
  }

  function handleForVariant(id) {
    var t = tierForVariant(id);
    return t ? t.handle : 'onam-500';
  }

  function itemHandle(item) {
    if (!item) return '';
    var props = item.properties || {};
    return props._if_gift_collection || props['_if_gift_collection'] || handleForVariant(item.variant_id);
  }

  function itemThreshold(item) {
    var t = tierForHandle(itemHandle(item)) || tierForVariant(item && item.variant_id);
    return t && t.threshold ? t.threshold : M2;
  }

  function discountForItem(item) {
    var t = tierForHandle(itemHandle(item)) || tierForVariant(item && item.variant_id);
    return (t && t.discountCode) || 'ONAM500FREE';
  }

  function currentDiscountCode(cart) {
    var gifts = cart ? giftItems(cart) : [];
    if (gifts.length) return discountForItem(gifts[0]);
    var rootEl = document.querySelector('[data-if-gift][data-selected-handle]');
    var handle = rootEl && rootEl.getAttribute('data-selected-handle');
    var t = handle && tierForHandle(handle);
    return (t && t.discountCode) || '';
  }

  function isGiftVariant(id) {
    if (!id) return false;
    return giftVariantIds().indexOf(String(id)) !== -1;
  }

  function isGiftItem(item) {
    if (!item) return false;
    const props = item.properties || {};
    return props._if_gift === 'true' || props['_if_gift'] === 'true';
  }

  function payableTotal(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      if (isGiftItem(item)) return sum;
      return sum + (item.final_line_price || 0);
    }, 0);
  }

  function giftItems(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(isGiftItem);
  }

  function toast(msg) {
    var el = document.getElementById('if-gift-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'if-gift-toast';
      el.className = 'if-gift-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () {
      el.classList.remove('is-on');
    }, 2400);
  }

  function formatMoney(cents) {
    const amount = Math.round(cents / 100);
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return '₹' + amount.toLocaleString('en-IN');
    }
  }

  var lastCart = null;

  function rememberCart(cart) {
    if (cart && cart.items) lastCart = cart;
    return cart;
  }

  function getCart() {
    return nativeFetch(root() + 'cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    }).then(rememberCart);
  }

  function previewAfterQty(itemKey, newQty) {
    if (!lastCart || !lastCart.items || !itemKey) return null;
    var items = lastCart.items.map(function (item) {
      if (item.key !== itemKey) return item;
      var qty = Math.max(0, Number(newQty) || 0);
      var unit = item.quantity ? Math.round(item.final_line_price / item.quantity) : item.final_price || 0;
      return Object.assign({}, item, {
        quantity: qty,
        final_line_price: unit * qty,
      });
    }).filter(function (item) {
      return item.quantity > 0;
    });
    var projected = { items: items, total_price: 0 };
    var payable = payableTotal(projected);
    projected.items = items.filter(function (item) {
      if (!isGiftItem(item)) return true;
      return payable >= itemThreshold(item);
    });
    projected.total_price = projected.items.reduce(function (sum, item) {
      return sum + (item.final_line_price || 0);
    }, 0);
    return projected;
  }

  function giftsToRemoveForQty(itemKey, newQty) {
    if (!lastCart) return [];
    var preview = previewAfterQty(itemKey, newQty);
    if (!preview) return [];
    var keep = {};
    giftItems(preview).forEach(function (g) {
      if (g.key) keep[g.key] = true;
    });
    return giftItems(lastCart).filter(function (g) {
      return g.key && g.key !== itemKey && !keep[g.key];
    });
  }

  function hideGiftLines() {
    document.querySelectorAll('.cart-item--gift').forEach(function (row) {
      row.hidden = true;
      row.style.display = 'none';
    });
  }

  function restoreGiftLines() {
    document.querySelectorAll('.cart-item--gift').forEach(function (row) {
      row.hidden = false;
      row.style.display = '';
    });
  }

  function changeLine(itemOrKey, quantity) {
    var payload = { quantity: quantity };
    if (itemOrKey && typeof itemOrKey === 'object') {
      if (itemOrKey.key) payload.id = itemOrKey.key;
      else payload.line = itemOrKey.line || itemOrKey.id;
    } else if (String(itemOrKey).indexOf(':') !== -1) {
      payload.id = itemOrKey;
    } else {
      payload.line = itemOrKey;
    }

    return nativeFetch(root() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json();
    });
  }

  function removeGifts(items) {
    if (!items.length) return Promise.resolve();
    var updates = {};
    items.forEach(function (item) {
      if (item.key) updates[item.key] = 0;
    });

    var request = Object.keys(updates).length
      ? nativeFetch(root() + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function (r) {
          return r.json();
        })
      : Promise.resolve();

    return request.then(getCart).then(function (cart) {
      var leftover = giftItems(cart).filter(function (g) {
        return items.some(function (item) {
          return (item.key && item.key === g.key) || String(item.variant_id) === String(g.variant_id);
        });
      });
      if (!leftover.length) return cart;

      return leftover
        .reduce(function (chain, item) {
          return chain.then(function () {
            return getCart().then(function (latest) {
              var idx = -1;
              (latest.items || []).forEach(function (it, i) {
                if (it.key === item.key || String(it.variant_id) === String(item.variant_id)) idx = i + 1;
              });
              if (idx > 0) return changeLine({ line: idx }, 0);
              return changeLine(item, 0);
            });
          });
        }, Promise.resolve())
        .then(getCart);
    });
  }

  function addGift(variantId, handle) {
    return nativeFetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: {
          _if_gift: 'true',
          _if_gift_collection: handle || handleForVariant(variantId),
        },
      }),
    }).then(function (r) {
      return r.json();
    });
  }

  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    return nativeFetch(root() + 'discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
      redirect: 'manual',
    }).catch(function () {});
  }

  function snapshotGiftScroll() {
    var tracks = [];
    document.querySelectorAll('.if-gift__track').forEach(function (track) {
      tracks.push({
        inDrawer: !!track.closest('cart-drawer'),
        left: track.scrollLeft,
      });
    });
    var items = document.querySelector('cart-drawer-items');
    return {
      tracks: tracks,
      itemsTop: items ? items.scrollTop : 0,
    };
  }

  function restoreGiftScroll(snap, variantId) {
    snap = snap || { tracks: [] };
    function apply() {
      document.querySelectorAll('.if-gift__track').forEach(function (track) {
        if (variantId) {
          var btn = track.querySelector('[data-variant-id="' + variantId + '"]');
          var card = btn && btn.closest('.if-gift__card');
          if (card) {
            var trackRect = track.getBoundingClientRect();
            var cardRect = card.getBoundingClientRect();
            track.scrollLeft += cardRect.left - trackRect.left - (track.clientWidth - cardRect.width) / 2;
            return;
          }
        }
        var inDrawer = !!track.closest('cart-drawer');
        var saved = (snap.tracks || []).filter(function (s) {
          return s.inDrawer === inDrawer;
        })[0];
        if (saved) track.scrollLeft = saved.left;
      });
      var items = document.querySelector('cart-drawer-items');
      if (items && snap.itemsTop) items.scrollTop = snap.itemsTop;
    }
    requestAnimationFrame(apply);
  }

  function refreshCartUI(opts) {
    var drawer = document.querySelector('cart-drawer');
    var rootUrl = root();
    opts = opts || {};

    return nativeFetch(rootUrl + '?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var snap = snapshotGiftScroll();
        if (drawer && sections['cart-drawer']) {
          var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var inner = parsed.querySelector('.drawer__inner');
          var current = drawer.querySelector('.drawer__inner');
          if (inner && current) current.innerHTML = inner.innerHTML;
          var srcDrawer = parsed.querySelector('cart-drawer');
          if (srcDrawer) drawer.classList.toggle('is-empty', srcDrawer.classList.contains('is-empty'));
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
          if (opts.open && typeof drawer.open === 'function') drawer.open();
        }

        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var bhtml = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var section = bhtml.querySelector('.shopify-section') || bhtml.body.firstElementChild;
            if (section) bubble.innerHTML = section.innerHTML;
          }
        }

        ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
          if (!sections[id]) return;
          var node = document.getElementById(id);
          if (!node) return;
          var html = new DOMParser().parseFromString(sections[id], 'text/html');
          var src = html.querySelector('.js-contents') || html.querySelector('#' + id);
          var dest = node.querySelector('.js-contents') || node;
          if (src && dest) dest.innerHTML = src.innerHTML;
        });

        restoreGiftScroll(snap, opts.focusVariantId);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        if (window.IfCartDelivery) window.IfCartDelivery.refresh();
        getCart().then(paintTiers);
      })
      .catch(function () {});
  }

  function buildGiftCard(product, handle, selectedId, unlocked) {
    var selected = String(product.variantId) === String(selectedId);
    var card = document.createElement('div');
    card.className = 'if-gift__card' + (selected ? ' is-selected' : '') + (product.available === false ? ' is-sold' : '');
    card.setAttribute('role', 'listitem');

    var media = document.createElement('div');
    media.className = 'if-gift__media';
    if (product.image) {
      var img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title || '';
      img.width = 120;
      img.height = 120;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    var badge = document.createElement('span');
    badge.className = 'if-gift__badge';
    badge.textContent = selected ? 'CLAIMED' : 'FREE';
    media.appendChild(badge);
    card.appendChild(media);

    var name = document.createElement('p');
    name.className = 'if-gift__name';
    name.textContent = product.title || '';
    card.appendChild(name);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'if-gift__btn' + (selected ? ' is-on' : '');
    btn.setAttribute('data-if-gift-add', '');
    btn.setAttribute('data-variant-id', String(product.variantId || ''));
    btn.setAttribute('data-gift-handle', handle);
    btn.setAttribute('data-title', product.title || '');
    if (product.available === false) {
      btn.disabled = true;
      btn.textContent = 'Sold out';
    } else if (selected) {
      btn.setAttribute('aria-pressed', 'true');
      btn.textContent = 'Claimed';
    } else if (!unlocked) {
      btn.disabled = true;
      btn.textContent = 'Locked';
    } else {
      btn.textContent = 'Claim';
    }
    card.appendChild(btn);
    return card;
  }

  function ensureGiftCards() {
    var selectedRoot = document.querySelector('[data-if-gift][data-selected]');
    var selectedId = selectedRoot && selectedRoot.getAttribute('data-selected');
    var unlocked500 = selectedRoot && selectedRoot.getAttribute('data-unlocked-500') === 'true';

    tiers().forEach(function (tier) {
      if (!tier || tier.handle === 'onam-125' || tier.handle === 'onam-250') return;
      var unlocked = unlocked500;
      document.querySelectorAll('[data-if-gift-track="' + tier.handle + '"]').forEach(function (track) {
        if (track.querySelector('.if-gift__card')) return;
        (tier.products || []).slice(0, 3).forEach(function (product) {
          if (!product || !product.variantId) return;
          track.appendChild(buildGiftCard(product, tier.handle, selectedId, unlocked));
        });
      });
    });
  }

  function paintTiers(cart) {
    if (cart && cart.items) {
      var payable = payableTotal(cart);
      var atM2 = payable >= M2;
      var claimedHandle = '';
      var gifts = giftItems(cart);
      if (gifts.length) claimedHandle = itemHandle(gifts[0]);

      document.querySelectorAll('[data-if-gift]').forEach(function (root) {
        root.classList.toggle('if-gift--unlocked', atM2);
        root.setAttribute('data-unlocked-250', 'false');
        root.setAttribute('data-unlocked-500', atM2 ? 'true' : 'false');
        if (gifts.length) {
          root.setAttribute('data-selected', String(gifts[0].variant_id || '0'));
          root.setAttribute('data-selected-handle', claimedHandle || '');
        }

        var t500 = root.querySelector('[data-gift-tier="500"]');
        if (t500) t500.classList.toggle('is-off', !atM2);

        var title = root.querySelector('.if-gift__title');
        var sub = root.querySelector('.if-gift__sub');
        if (!title) return;

        if (gifts.length) {
          title.textContent = 'Free gift claimed';
          if (sub) sub.textContent = 'One free gift per order';
        } else if (atM2) {
          title.textContent = 'Pick your free gift';
          if (sub) sub.textContent = 'Unlocked at ₹999 · one per order';
        }
      });
    }
    ensureGiftCards();
  }

  function sync(cart) {
    if (!cart) return Promise.resolve(cart);
    paintTiers(cart);
    if (syncing || busy) return Promise.resolve(cart);
    var gifts = giftItems(cart);
    var payable = payableTotal(cart);
    var changed = false;
    var ops = Promise.resolve(cart);

    var overTier = gifts.filter(function (g) {
      return payable < itemThreshold(g);
    });

    if (overTier.length) {
      changed = true;
      syncing = true;
      ops = removeGifts(overTier).then(getCart);
    } else if (gifts.length > 1) {
      changed = true;
      syncing = true;
      var keep = gifts[0];
      ops = removeGifts(gifts.slice(1))
        .then(function () {
          if (keep.quantity > 1) return changeLine(keep, 1);
        })
        .then(getCart);
    } else if (gifts.length === 1 && gifts[0].quantity > 1) {
      changed = true;
      syncing = true;
      ops = changeLine(gifts[0], 1).then(getCart);
    }

    return ops
      .then(function (next) {
        var latest = next || cart;
        rememberCart(latest);
        var kept = giftItems(latest);
        if (kept.length && payableTotal(latest) >= itemThreshold(kept[0])) {
          return applyDiscount(discountForItem(kept[0])).then(function () {
            return latest;
          });
        }
        return latest;
      })
      .then(function (latest) {
        if (changed) {
          return refreshCartUI().then(function () {
            return latest;
          });
        }
        return latest;
      })
      .finally(function () {
        syncing = false;
      });
  }

  function ensureLoader() {
    var el = document.getElementById('if-gift-loader');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'if-gift-loader';
    el.className = 'if-gift-loader';
    el.hidden = true;
    el.innerHTML =
      '<div class="if-gift-loader__box" role="status" aria-live="polite">' +
      '<span class="if-gift-loader__spin" aria-hidden="true"></span>' +
      '<p class="if-gift-loader__msg">Claiming gift…</p></div>';
    document.body.appendChild(el);
    return el;
  }

  function showGiftLoader(message) {
    document.body.classList.add('if-gift-busy');
    var modal = document.getElementById('if-gift-modal');
    if (modal && !modal.hidden && modal.classList.contains('is-busy')) return;
    var el = ensureLoader();
    var msg = el.querySelector('.if-gift-loader__msg');
    if (msg) msg.textContent = message || 'Claiming gift…';
    el.hidden = false;
  }

  function hideGiftLoader() {
    document.body.classList.remove('if-gift-busy');
    var el = document.getElementById('if-gift-loader');
    if (el) el.hidden = true;
    closeGiftModal();
  }

  function closeGiftModal(drawer) {
    var modal = document.getElementById('if-gift-modal');
    if (!modal) return;
    modal.hidden = true;
    modal.classList.remove('is-busy');
    document.body.classList.remove('if-gift-modal-open');
    drawer = drawer || document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof trapFocus === 'function') {
      var trapOn = document.getElementById('CartDrawer') || drawer;
      trapFocus(trapOn, drawer.querySelector('.drawer__inner') || trapOn);
    }
  }

  function productTitle(variantId) {
    var match = products().filter(function (p) {
      return String(p.variantId) === String(variantId);
    })[0];
    return match ? match.title : 'this gift';
  }


  function ensureModal() {
    var el = document.getElementById('if-gift-modal');
    if (el && !el.querySelector('.if-gift-modal__from')) {
      el.remove();
      el = null;
    }
    if (el) return el;
    el = document.createElement('div');
    el.id = 'if-gift-modal';
    el.className = 'if-gift-modal';
    el.hidden = true;
    el.innerHTML =
      '<div class="if-gift-modal__panel" role="dialog" aria-modal="true" aria-labelledby="if-gift-modal-title">' +
      '<p class="if-gift-modal__title" id="if-gift-modal-title">Replace free gift?</p>' +
      '<p class="if-gift-modal__intro">Only 1 free gift is allowed. Remove the current one to claim this?</p>' +
      '<div class="if-gift-modal__swap">' +
      '<p class="if-gift-modal__row"><span>Now</span><strong class="if-gift-modal__from"></strong></p>' +
      '<p class="if-gift-modal__row"><span>Claim</span><strong class="if-gift-modal__to"></strong></p>' +
      '</div>' +
      '<div class="if-gift-modal__actions">' +
      '<button type="button" class="if-gift-modal__btn if-gift-modal__btn--ghost" data-if-gift-modal-cancel>Keep current</button>' +
      '<button type="button" class="if-gift-modal__btn if-gift-modal__btn--yes" data-if-gift-modal-confirm>Yes, replace</button>' +
      '</div>' +
      '<div class="if-gift-modal__progress" role="status">' +
      '<span class="if-gift-loader__spin" aria-hidden="true"></span>' +
      '<p>Replacing gift…</p>' +
      '</div></div>';
    document.body.appendChild(el);
    return el;
  }

  function confirmReplace(fromTitle, toTitle) {
    return new Promise(function (resolve) {
      var modal = ensureModal();
      var drawer = document.querySelector('cart-drawer');
      modal.classList.remove('is-busy');
      var title = modal.querySelector('.if-gift-modal__title');
      if (title) title.textContent = 'Replace free gift?';
      modal.querySelector('.if-gift-modal__from').textContent = fromTitle || 'your current gift';
      modal.querySelector('.if-gift-modal__to').textContent = toTitle || 'this gift';
      modal.hidden = false;
      document.body.classList.add('if-gift-modal-open');
      if (typeof removeTrapFocus === 'function') removeTrapFocus();

      function finish(ok) {
        modal.removeEventListener('click', onClick);
        document.removeEventListener('keydown', onKey, true);
        if (ok) {
          modal.classList.add('is-busy');
          var heading = modal.querySelector('.if-gift-modal__title');
          if (heading) heading.textContent = 'Replacing gift…';
          resolve(true);
          return;
        }
        closeGiftModal(drawer);
        resolve(false);
      }

      function onClick(e) {
        if (e.target.closest('[data-if-gift-modal-confirm]')) finish(true);
        else if (e.target.closest('[data-if-gift-modal-cancel]')) finish(false);
        else if (!e.target.closest('.if-gift-modal__panel')) finish(false);
      }

      function onKey(e) {
        if (e.key === 'Escape' || e.code === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          finish(false);
        }
      }

      modal.addEventListener('click', onClick);
      document.addEventListener('keydown', onKey, true);
      var yes = modal.querySelector('[data-if-gift-modal-confirm]');
      if (yes) yes.focus();
    });
  }

  function claim(variantId, opts) {
    opts = opts || {};
    if (busy) return Promise.resolve();
    variantId = String(variantId);
    if (!isGiftVariant(variantId)) return Promise.resolve();
    var handle = opts.handle || handleForVariant(variantId);

    var selectedRoot = document.querySelector('[data-if-gift][data-selected]');
    var selectedId = selectedRoot && selectedRoot.getAttribute('data-selected');
    var needsReplace = selectedId && selectedId !== '0' && selectedId !== variantId && !opts.skipConfirm;

    busy = true;
    document.body.classList.add('if-gift-busy');

    if (needsReplace) {
      var fromCard = document.querySelector('.if-gift__card.is-selected .if-gift__name');
      var fromTitle = fromCard ? fromCard.textContent.trim() : 'your current gift';
      return confirmReplace(fromTitle, productTitle(variantId)).then(function (ok) {
        if (!ok) {
          busy = false;
          return null;
        }
        return executeClaim(variantId, true, handle);
      });
    }

    showGiftLoader('Claiming gift…');
    return executeClaim(variantId, false, handle);
  }

  function executeClaim(variantId, replacing, handle) {
    handle = handle || handleForVariant(variantId);
    var tier = tierForHandle(handle) || tierForVariant(variantId);
    var need = (tier && tier.threshold) || M2;
    var code = (tier && tier.discountCode) || 'ONAM500FREE';
    var btn = document.querySelector('[data-if-gift-add][data-variant-id="' + variantId + '"]');
    if (btn) {
      btn.classList.add('is-busy');
      btn.textContent = replacing ? 'Replacing…' : 'Claiming…';
    }
    if (!replacing) showGiftLoader('Claiming gift…');

    return getCart()
      .then(function (cart) {
        var payable = payableTotal(cart);
        if (payable < need) {
          toast('Add ' + formatMoney(need - payable) + ' more to unlock this gift');
          return null;
        }

        var existing = giftItems(cart);
        var already = existing.filter(function (item) {
          return String(item.variant_id) === variantId;
        })[0];
        if (already) {
          toast('You already claimed this free gift');
          return cart;
        }

        if (existing.length && !replacing) {
          hideGiftLoader();
          return confirmReplace(existing[0].product_title || 'your current gift', productTitle(variantId)).then(
            function (ok) {
              if (!ok) return null;
              document.body.classList.add('if-gift-busy');
              return executeClaim(variantId, true, handle);
            }
          );
        }

        return removeGifts(existing)
          .then(function () {
            return addGift(variantId, handle);
          })
          .then(function (res) {
            if (res && res.status) {
              toast(res.description || 'Could not claim gift');
              return null;
            }
            applyDiscount(code);
            toast(replacing || existing.length ? 'Free gift replaced' : 'Free gift claimed');
            return refreshCartUI({ open: true, focusVariantId: variantId }).then(function () {
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') drawer.open();
              return res;
            });
          });
      })
      .finally(function () {
        busy = false;
        hideGiftLoader();
        if (btn) btn.classList.remove('is-busy');
      });
  }

  function afterCartChange(cart) {
    if (!cart || !cart.items) {
      return getCart().then(afterCartChange);
    }
    return sync(cart).then(function (next) {
      if (next && JSON.stringify(giftItems(next)) !== JSON.stringify(giftItems(cart))) {
        return refreshCartUI();
      }
    });
  }

  function parseAddBody(init) {
    if (!init || !init.body) return null;
    try {
      if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
        return init.body.get('id') || init.body.get('items[0][id]');
      }
      if (typeof init.body === 'string') {
        try {
          var json = JSON.parse(init.body);
          if (json.id) return json.id;
          if (json.items && json.items[0]) return json.items[0].id;
        } catch (e) {
          var params = new URLSearchParams(init.body);
          return params.get('id');
        }
      }
    } catch (e) {}
    return null;
  }

  function installFetchGuard() {
    if (window.fetch && window.fetch.__ifGift) return;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') !== -1) {
        var variantId = parseAddBody(init);
        if (isGiftVariant(variantId)) {
          return getCart().then(function (cart) {
            var tier = tierForVariant(variantId);
            var need = (tier && tier.threshold) || M2;
            if (payableTotal(cart) < need) {
              return nativeFetch(input, init);
            }
            return claim(variantId).then(function (cart) {
              if (!cart) {
                return new Response(
                  JSON.stringify({ status: 422, description: 'Gift not added', message: 'Gift not added' }),
                  { status: 422, headers: { 'Content-Type': 'application/json' } }
                );
              }
              return new Response(JSON.stringify(cart), {
                status: 200,
                headers: { 'Content-Type': 'application/json' },
              });
            });
          });
        }
      }
      return nativeFetch(input, init);
    };
    window.fetch.__ifGift = true;
  }

  function interceptForms() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.getAttribute) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;
        var idInput = form.querySelector('[name="id"]');
        if (!idInput || !isGiftVariant(idInput.value)) return;
        e.preventDefault();
        e.stopPropagation();
        var variantId = idInput.value;
        getCart().then(function (cart) {
          var tier = tierForVariant(variantId);
          var need = (tier && tier.threshold) || M2;
          if (payableTotal(cart) < need) {
            return nativeFetch(form.action || root() + 'cart/add', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
              body: new FormData(form),
            }).then(function (r) {
              return r.json();
            }).then(function (data) {
              if (data && data.items) rememberCart(data);
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
            });
          }
          return claim(variantId).then(function () {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          });
        });
      },
      true
    );
  }

  function interceptClicks() {
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-if-gift-add]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (addBtn.disabled || addBtn.classList.contains('is-on')) return;
        claim(addBtn.getAttribute('data-variant-id'), {
          handle: addBtn.getAttribute('data-gift-handle'),
        });
        return;
      }

      var checkout = e.target.closest('[name="checkout"], .cart__checkout-button');
      if (!checkout || checkout.disabled) return;
      var selected = document.querySelector('[data-if-gift][data-selected]') || document.querySelector('.cart-item--gift');
      if (!selected) return;
      var selectedId = selected.getAttribute && selected.getAttribute('data-selected');
      if (selectedId === '0' && !document.querySelector('.cart-item--gift')) return;
      var code = currentDiscountCode();
      if (!code) return;

      e.preventDefault();
      e.stopPropagation();
      window.location.href = root() + 'discount/' + encodeURIComponent(code) + '?redirect=/checkout';
    });
  }

  function init() {
    installFetchGuard();
    interceptForms();
    interceptClicks();
    ensureGiftCards();
    getCart().then(paintTiers);

    document.addEventListener('cart:updated', function (e) {
      var detail = e.detail;
      var cart = (detail && detail.cart) || (detail && detail.items ? detail : null);
      if (cart && cart.items) afterCartChange(cart);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && event.cartData.items) afterCartChange(event.cartData);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return {
    claim: claim,
    sync: sync,
    isGiftVariant: isGiftVariant,
    payableTotal: payableTotal,
    THRESHOLD: THRESHOLD,
    M1: M1,
    M2: M2,
    paintTiers: paintTiers,
    rememberCart: rememberCart,
    giftsToRemoveForQty: giftsToRemoveForQty,
    previewAfterQty: previewAfterQty,
    hideGiftLines: hideGiftLines,
    restoreGiftLines: restoreGiftLines,
    isGiftItem: isGiftItem,
  };
})();
